import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { createErrorHandler } from '@sentry/angular';
import { PopupService } from 'app/core/services/popup.service';

export const isDynamicImportError = (error: any) => {
  const msg = error?.message || error?.error?.message || error || '';
  return ['Failed to fetch dynamically imported module:', 'Failed to load module script', 'error loading dynamically imported module'].some((substring) =>
    msg.includes(substring)
  );
};

@Injectable()
export class GlobalErrorInterceptor implements ErrorHandler {
  private _popupService: PopupService = inject(PopupService);

  invalidStatuses(error: any) {
    return error.status === 401 || error.status === 408 || error.status === 0 || error.status === 503 || error.status === 403;
  }

  handleError(error: any) {
    const sentryHandler = createErrorHandler({
      showDialog: false
    });

    if (isDynamicImportError(error)) {
      return window.location.reload();
    }
    if (!(error instanceof HttpErrorResponse && this.invalidStatuses(error))) {
      sentryHandler.handleError(error);
    }
  }
}
